import { Typography } from "@mui/material";

export function SectionHeading() {
  return (
    <Typography
  sx={{
    alignSelf: "center",
    fontFamily: "Inter600",
    fontSize: { xs: "32px", sm: "40px", md: "48px" }, // more granular responsiveness
    fontWeight: 600,
    color: "white",
    mb: { xs: 4, sm: 5 }, // spacing below the heading
     "@media (max-height:645px)":{
        fontSize:"40px",
        mb:4
    },
  }}
>
  Our Products
</Typography>

  );
}
